import { Modal } from "antd";

interface InvoiceConfirmBackModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function InvoiceConfirmBackModal({
  open,
  onCancel,
  onConfirm,
}: InvoiceConfirmBackModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Discard changes?"
      footer={
        <div className="flex justify-end gap-2">
          <button className="btn btn-gray" onClick={onCancel}>
            Stay
          </button>

          <button className="btn btn-red" onClick={onConfirm}>
            Discard changes
          </button>
        </div>
      }
    >
      <p className="text-gray-600">
        You have unsaved changes. If you go back now, those changes will be
        lost.
      </p>
    </Modal>
  );
}
